import { clone } from "./clone"

export * from "./clone"
export const ShaderUtils = {
    clone
}